import { ItfProductFloorBtn, ItfProductFloorChild, ItfProductFloorData, ItfProductFloorItem, ItfProductFloorLink } from './type';

export const defaultBtn: ItfProductFloorBtn = {
    type: 'fill',
    text: '',
    url: '',
    color: 'white',
    bgColor: 'black',
};

export const defaultLink: ItfProductFloorLink = {
    text: '',
    url: '',
};

export const defaultItem: ItfProductFloorItem = {
    label: '',
    labelColor: '#3F68E0',
    name: '',
    text: '',
    btns: [defaultBtn],
    img: '',
    hoverImg: '',
    hoverImgH5: '',
    btnsType: 'X',
};

export const defaultChild: ItfProductFloorChild = {
    tab: '',
    label: '',
    labelColor: '#3F68E0',
    name: '',
    nameColor: 'black',
    text: '',
    textColor: '#83868A',
    pc: '',
    h5: '',
    btns: [defaultBtn],
    links: [defaultLink],
    items: [defaultItem],
};

export const configData: ItfProductFloorData = {
    theme: 'white',
    title: '',
    titleColor: 'black',
    desc: '',
    descColor: '#83868A',
    children: [defaultChild],
};
